import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Harish Kumar - Digital Marketing Expert & Web Developer | Ahmedabad",
  description = "Expert Digital Marketing Consultant & Full-Stack Web Developer in Ahmedabad. Specializing in Facebook Ads, Google Ads, SEO, Social Media Marketing, and Custom Web Development. Get measurable results for your business.",
  keywords = "digital marketing consultant ahmedabad, facebook ads expert, google ads specialist, social media marketing, web developer ahmedabad, SEO expert, PPC consultant, performance marketing, brand building, lead generation",
  image = "https://portfolioweb.fliphatmedia.com/images/harish-kumar-og-image.jpg",
  url = "https://portfolioweb.fliphatmedia.com",
  type = "website",
  section = ""
}) => {
  const fullTitle = section ? `${section} | ${title}` : title;
  const canonicalUrl = section ? `${url}#${section.toLowerCase()}` : url;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="author" content="Harish Kumar" />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      
      {/* Structured Data for specific sections */}
      {section === 'About' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "mainEntity": {
              "@type": "Person",
              "name": "Harish Kumar",
              "jobTitle": "Digital Marketing Expert & Web Developer",
              "description": "Expert Digital Marketing Consultant and Full-Stack Web Developer specializing in Facebook Ads, Google Ads, SEO, and custom web development solutions.",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ahmedabad",
                "addressRegion": "Gujarat",
                "addressCountry": "IN"
              },
              "email": "contact@portfolioweb.fliphatmedia.com",
              "telephone": "+919602003790"
            }
          })}
        </script>
      )}
      
      {section === 'Portfolio' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CreativeWork",
            "name": "Digital Marketing & Web Development Portfolio",
            "author": {
              "@type": "Person",
              "name": "Harish Kumar"
            },
            "description": "Portfolio showcasing digital marketing campaigns, web development projects, and performance marketing results.",
            "keywords": ["Digital Marketing", "Web Development", "Portfolio", "Facebook Ads", "Google Ads", "SEO"]
          })}
        </script>
      )}
      
      {section === 'Services' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Digital Marketing & Web Development Services",
            "provider": {
              "@type": "Person",
              "name": "Harish Kumar"
            },
            "serviceType": [
              "Digital Marketing",
              "Facebook Advertising", 
              "Google Ads Management",
              "Social Media Marketing",
              "Web Development",
              "SEO Services"
            ],
            "areaServed": "India",
            "description": "Professional digital marketing and web development services to grow your business online."
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
